export const sentryDsn =
  "https://f68a3b54dacb2205e14f347beb2c7f40@o617258.ingest.us.sentry.io/4511937528266752"

export const sentryEnvironment =
  process.env.GATSBY_ENVIRONMENT_NAME || "development"

export const sentryEnabled = ["staging", "production"].includes(
  sentryEnvironment
)

export const sentryBaseConfig = {
  dsn: sentryDsn,
  environment: sentryEnvironment,
  enabled: sentryEnabled,
}
